export default {
    buttons: {
        lecture: 'กับครู',
        self: 'เรียนด้วยตนเอง',
        task: 'การบ้าน',
    },
    moduleLabel: {
        cardWriting: 'เขียนการ์ด 💬️',
        wordCheck: 'ตรวจคำศัพท์',
        wordWriting: 'เขียนคำศัพท์',
        wordSelection: 'เลือกคำศัพท์',
        seedLetter: 'ตัวอักษรเริ่มต้น',
        oxQuiz: 'ควิซ OX',
        fillInTheBlanks: 'เติมคำในช่องว่าง',
        proConDebate: 'โต้วาที',
        segmentedReading: 'อ่านทีละส่วน',
        sentenceOrdering: 'เรียงประโยค',
        correctTheMistakes: 'แก้ไขข้อผิดพลาด',
        postIt: 'เติมตารางให้สมบูรณ์',
        magicWordTest: 'ฉันรู้! ไม่รู้?',
        talkQuiz: 'ควิซพูดคุย',
    },
};
